<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M8.88889 10.2784C8.88889 9.66622 9.38777 9.16733 10 9.16733C10.6122 9.16733 11.1111 9.66622 11.1111 10.2784C11.1111 10.8907 10.6122 11.3896 10 11.3896C9.38777 11.3896 8.88889 10.8907 8.88889 10.2784Z"
            fill="currentColor"
        />
        <path
            d="M13.8889 11.3896C14.5011 11.3896 15 10.8907 15 10.2784C15 9.66622 14.5011 9.16733 13.8889 9.16733C13.2767 9.16733 12.7778 9.66622 12.7778 10.2784C12.7778 10.8907 13.2767 11.3896 13.8889 11.3896Z"
            fill="currentColor"
        />
        <path
            d="M8.88889 13.6118C8.88889 12.9995 9.38777 12.5007 10 12.5007C10.6122 12.5007 11.1111 12.9995 11.1111 13.6118C11.1111 14.224 10.6122 14.7229 10 14.7229C9.38777 14.7229 8.88889 14.224 8.88889 13.6118Z"
            fill="currentColor"
        />
        <path
            d="M6.11111 12.5007C5.49889 12.5007 5 12.9995 5 13.6118C5 14.224 5.49889 14.7229 6.11111 14.7229C6.72333 14.7229 7.22222 14.224 7.22222 13.6118C7.22222 12.9995 6.72333 12.5007 6.11111 12.5007Z"
            fill="currentColor"
        />
        <path
            d="M12.7778 13.6118C12.7778 12.9995 13.2767 12.5007 13.8889 12.5007C14.5011 12.5007 15 12.9995 15 13.6118C15 14.224 14.5011 14.7229 13.8889 14.7229C13.2767 14.7229 12.7778 14.224 12.7778 13.6118Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.38889 0.0839844C6.8031 0.0839844 7.13889 0.419771 7.13889 0.833984V2.30621H12.8611V0.833984C12.8611 0.419771 13.1969 0.0839844 13.6111 0.0839844C14.0253 0.0839844 14.3611 0.419771 14.3611 0.833984V2.30621H15.2778C16.9193 2.30621 18.25 3.63692 18.25 5.27844V14.7229C18.25 16.3644 16.9193 17.6951 15.2778 17.6951H4.72222C3.08071 17.6951 1.75 16.3644 1.75 14.7229V5.27844C1.75 3.63692 3.08071 2.30621 4.72222 2.30621H5.63889V0.833984C5.63889 0.419771 5.97467 0.0839844 6.38889 0.0839844ZM16.75 5.27844V6.1951H3.25V5.27844C3.25 4.46535 3.90914 3.80621 4.72222 3.80621H15.2778C16.0909 3.80621 16.75 4.46535 16.75 5.27844ZM16.75 7.6951H3.25V14.7229C3.25 15.536 3.90914 16.1951 4.72222 16.1951H15.2778C16.0909 16.1951 16.75 15.536 16.75 14.7229V7.6951Z"
            fill="currentColor"
        />
    </svg>
</template>
